type IconProps = {
  color?: string;
  size?: number;
  className?: string;
};

export function IconCentralKitchen({
  color = "black",
  size = 14,
  className,
}: IconProps) {
  const height = (size * 13) / 14;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35279 2.14885C8.44714 1.95249 8.5 1.73242 8.5 1.5C8.5 0.671573 7.82843 0 7 0C6.17157 0 5.5 0.671573 5.5 1.5C5.5 1.73242 5.55286 1.95249 5.64721 2.14885C2.89218 2.76548 0.833333 5.22564 0.833333 8.16667C0.833333 8.44281 1.05719 8.66667 1.33333 8.66667H12.6667C12.9428 8.66667 13.1667 8.44281 13.1667 8.16667C13.1667 5.22564 11.1078 2.76548 8.35279 2.14885ZM7 1C6.72386 1 6.5 1.22386 6.5 1.5C6.5 1.77614 6.72386 2 7 2C7.27614 2 7.5 1.77614 7.5 1.5C7.5 1.22386 7.27614 1 7 1ZM8.55383 4.25791C8.71007 4.03022 9.02131 3.97229 9.249 4.12853C9.78156 4.49398 10.2203 4.99205 10.5181 5.57852C10.6431 5.82474 10.5449 6.12569 10.2987 6.25071C10.0525 6.37574 9.75151 6.27749 9.62649 6.03127C9.40459 5.59427 9.07795 5.22395 8.6832 4.95308C8.45551 4.79684 8.39759 4.4856 8.55383 4.25791Z"
        fill={color}
      />
      <path
        d="M0.333334 9.5C0.149239 9.5 1.05406e-07 9.64924 1.05406e-07 9.83333V9.98072C-3.5196e-06 10.2955 -6.47207e-06 10.5519 0.0170022 10.7601C0.0345813 10.9752 0.0719775 11.168 0.163491 11.3477C0.307301 11.6299 0.536771 11.8594 0.819014 12.0032C0.998619 12.0947 1.19143 12.1321 1.40659 12.1497C1.61477 12.1667 1.87118 12.1667 2.18595 12.1667H11.8141C12.1288 12.1667 12.3852 12.1667 12.5934 12.1497C12.8086 12.1321 13.0014 12.0947 13.181 12.0032C13.4632 11.8594 13.6927 11.6299 13.8365 11.3477C13.928 11.168 13.9654 10.9752 13.983 10.7601C14 10.5519 14 10.2955 14 9.98072V9.83333C14 9.64924 13.8508 9.5 13.6667 9.5H0.333334Z"
        fill={color}
      />
    </svg>
  );
}
